import React from "react";
import img1 from "../../images/optionalChoice.png";
import img2 from "../../images/improvement.png";
import img3 from "../../images/job-offer.png";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";

export default function AgriEntrepenurBenefits() {
  const benefits = [
    {
      img: img1,
      title: "New Asset Class",
      bodycopy: "Can provide new Asset Class for investment that is tangible for investors.",
    },
    {
      img: img2,
      title: "Improve Economy",
      bodycopy: "Investable trade in Agriculture bring a cascading increase in Agricultural production and  improves the GDP.",
    },
    {
      img: img3,
      title: "Create Jobs",
      bodycopy:
        "Investable trade concept for agriculture asset class will help to create more Rural jobs.",
    },
  ];
  return (
    <div className=" subSectionWrapper">
      <h2 className="text-center container-title">
        Agri-storage entreprenuer Contribution
      </h2>
      <Row>
        {benefits.map((e) => {
          return (
            <Col md={4} className="d-flex">
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
